<template>
  <nav class="mt-4 d-flex justify-content-between ">
    <div class="d-flex justify-content-start">
      <form class="form-inline">
        <span>{{ $t("label.mostrar") }}</span>
        <div class="form-group mx-sm-3">
          <label class="sr-only">{{ $t("label.registros") }}</label>
          <select
            class="form-control"
            v-model="tamanhoAtual"
            @change="onClickPagina(0, tamanhoAtual)"
          >
            <option>5</option>
            <option>10</option>
            <option>25</option>
            <option>50</option>
            <option>100</option>
          </select>
        </div>
        <span>Registros</span>
      </form>
    </div>
    <div class="d-flex justify-content-end">
      <span class="mt-2 mr-2"
        >{{ numeroElementoInicio }} - {{ numeroElementoFim }} de
        {{ totalElementos }}</span
      >
      <a
        href="javascript:void(0)"
        class="btn btn-pagination btn-sm ml-1"
        :class="{ disabled: !temAnterior }"
        role="button"
        aria-disabled="true"
        @click="onClickPagina(paginaAtual - 1, tamanhoAtual)"
      >
        <i class="material-icons">
          keyboard_arrow_left
        </i>
      </a>
      <a
        href="javascript:void(0)"
        class="btn btn-pagination btn-sm ml-1"
        :class="{ disabled: !temProximo }"
        role="button"
        aria-disabled="true"
        @click="onClickPagina(paginaAtual + 1, tamanhoAtual)"
      >
        <i class="material-icons">
          keyboard_arrow_right
        </i>
      </a>
    </div>
  </nav>

  <!--  <div class="paginacao d-flex flex-row-reverse">-->
  <!--    <ul class="pagination" v-if="paginas.length">-->
  <!--      <li class="page-item" :class="{ disabled: !temAnterior }">-->
  <!--        <a-->
  <!--          class="page-link primeira-pagina"-->
  <!--          href="javascript:void(0)"-->
  <!--          @click="onClickPagina(0)"-->
  <!--        >-->
  <!--          <span aria-hidden="true">&laquo;</span>-->
  <!--          <span class="sr-only">{{primeiraText}}</span>-->
  <!--        </a>-->
  <!--      </li>-->

  <!--      <li class="page-item" :class="{ disabled: !temAnterior }">-->
  <!--        <a-->
  <!--          class="page-link pagina-anterior"-->
  <!--          href="javascript:void(0)"-->
  <!--          @click="onClickPagina(paginaAtual - 1)"-->
  <!--        >-->
  <!--          <span aria-hidden="true">&lsaquo;</span>-->
  <!--          <span class="sr-only">{{anteriorText}}</span>-->
  <!--        </a>-->
  <!--      </li>-->

  <!--      <li v-if="temIntervaloAnterior" class="page-item disabled">-->
  <!--        <span class="page-link">...</span>-->
  <!--      </li>-->

  <!--      <li-->
  <!--        class="page-item"-->
  <!--        v-for="pagina in paginas"-->
  <!--        :key="pagina"-->
  <!--        :class="{ active: pagina === paginaAtual }"-->
  <!--      >-->
  <!--        <a-->
  <!--          class="page-link"-->
  <!--          :class="'pagina-' + (pagina + 1)"-->
  <!--          href="javascript:void(0)"-->
  <!--          @click="onClickPagina(pagina)"-->
  <!--        >-->
  <!--          {{ pagina + 1 }}-->
  <!--          <span v-if="pagina === paginaAtual" class="sr-only">({{atualText}})</span>-->
  <!--        </a>-->
  <!--      </li>-->

  <!--      <li v-if="temIntervaloProximo" class="page-item disabled">-->
  <!--        <span class="page-link">...</span>-->
  <!--      </li>-->

  <!--      <li class="page-item" :class="{ disabled: !temProximo }">-->
  <!--        <a-->
  <!--          class="page-link proxima-pagina"-->
  <!--          href="javascript:void(0)"-->
  <!--          @click="onClickPagina(paginaAtual + 1)"-->
  <!--        >-->
  <!--          <span aria-hidden="true">&rsaquo;</span>-->
  <!--          <span class="sr-only">{{proximaText}}</span>-->
  <!--        </a>-->
  <!--      </li>-->

  <!--      <li class="page-item" :class="{ disabled: !temProximo }">-->
  <!--        <a-->
  <!--          class="page-link ultima-pagina"-->
  <!--          href="javascript:void(0)"-->
  <!--          @click="onClickPagina(ultimaPagina)"-->
  <!--        >-->
  <!--          <span aria-hidden="true">&raquo;</span>-->
  <!--          <span class="sr-only">{{ultimaText}}</span>-->
  <!--        </a>-->
  <!--      </li>-->
  <!--    </ul>-->
  <!--  </div>-->
</template>

<script>
import { range } from "lodash-es";

const INTERVALO = 1;
const INTERVALO_MAXIMO = 2;

export default {
  name: "HcPaginacao",
  model: {
    prop: "paginaAtiva",
    event: "trocar-pagina"
  },
  props: {
    paginaAtiva: {
      type: Number,
      default: 0
    },
    totalPaginas: {
      type: Number,
      default: 0
    },
    totalElementos: {
      type: Number,
      default: 0
    },
    tamanhoPagina: {
      type: Number,
      default: 5
    },
    totalElementosPagina: {
      type: Number,
      default: 0
    },
    mantemEstado: {
      type: Boolean,
      default: false
    },
    primeiraText: {
      type: String,
      default: "Primeira"
    },
    ultimaText: {
      type: String,
      default: "Última"
    },
    proximaText: {
      type: String,
      default: "Proxima"
    },
    anteriorText: {
      type: String,
      default: "Anterior"
    },
    atualText: {
      type: String,
      default: "Atual"
    }
  },
  mounted: setupEstadoInicial,
  data,
  computed: {
    temAnterior,
    temIntervaloAnterior,
    temProximo,
    temIntervaloProximo,
    paginas,
    ultimaPagina,
    numeroElementoInicio,
    numeroElementoFim
  },
  methods: {
    onClickPagina,
    setPaginaAtual,
    updateQueryParam
  },
  watch: {
    paginaAtiva,
    tamanhoPagina
  }
};

function data() {
  return {
    paginaAtual: this.paginaAtiva,
    tamanhoAtual: this.tamanhoPagina
  };
}

function temAnterior() {
  return this.paginaAtual > 0;
}

function temIntervaloAnterior() {
  if (this.paginaAtual === this.ultimaPagina) {
    return this.paginaAtual > INTERVALO_MAXIMO;
  } else {
    return this.paginaAtual > INTERVALO;
  }
}

function temIntervaloProximo() {
  if (this.paginaAtual === 0) {
    return this.paginaAtual + INTERVALO_MAXIMO < this.ultimaPagina;
  } else {
    return this.paginaAtual + INTERVALO < this.ultimaPagina;
  }
}

function temProximo() {
  return this.paginaAtual < this.ultimaPagina;
}

function paginas() {
  let inicioIntervalo = 0;
  const intervaloMaximo = getIntervaloMaximo(this.ultimaPagina);
  let fimIntervalo = intervaloMaximo;

  if (isPontasIntervalo(this.paginaAtual, this.ultimaPagina)) {
    if (!this.temProximo) {
      inicioIntervalo = this.paginaAtual - intervaloMaximo;
      fimIntervalo = this.ultimaPagina;
    }
  } else if (isPaginaAtualMaiorQueIntervalo(this.paginaAtual)) {
    if (isPaginaAtualMenorQueUltima(this.paginaAtual, this.ultimaPagina)) {
      inicioIntervalo = this.paginaAtual - INTERVALO;
      fimIntervalo = this.paginaAtual + INTERVALO;
    } else {
      fimIntervalo = this.ultimaPagina;
      inicioIntervalo = fimIntervalo - intervaloMaximo;
    }
  }

  return range(inicioIntervalo, fimIntervalo + 1);
}

function ultimaPagina() {
  if (this.totalPaginas > 0) {
    return this.totalPaginas - 1;
  }

  return 0;
}

function onClickPagina(pagina, tamanho) {
  this.setPaginaAtual(pagina);

  this.updateQueryParam();

  this.$emit("trocar-pagina", { pagina, tamanho });
}

function setPaginaAtual(pagina) {
  pagina = pagina < this.ultimaPagina ? pagina : this.ultimaPagina;

  this.paginaAtual = pagina;
}

function updateQueryParam() {
  if (this.mantemEstado) {
    this.$router.replace({
      query: {
        ...this.$route.query,
        pagina: this.paginaAtual,
        tamanho: this.tamanhoAtual
      }
    });
  }
}

function paginaAtiva() {
  this.setPaginaAtual(this.paginaAtiva);
  this.updateQueryParam();
}

function tamanhoPagina() {
  this.tamanhoAtual = this.tamanhoPagina;
  this.updateQueryParam();
}

function setupEstadoInicial() {
  if (this.mantemEstado) {
    this.$router.onReady(() => {
      let { pagina } = this.$route.query;
      if (pagina != null) {
        this.setPaginaAtual(+pagina);
      }

      let { tamanho } = this.$route.query;
      if (tamanho != null) {
        this.tamanhoAtual = tamanho;
      }
    });
  }
}

function getIntervaloMaximo(ultimaPagina) {
  if (ultimaPagina >= INTERVALO_MAXIMO) {
    return INTERVALO_MAXIMO;
  }

  return ultimaPagina;
}

function isPontasIntervalo(paginaAtual, ultimaPagina) {
  return paginaAtual === 0 || paginaAtual === ultimaPagina;
}

function isPaginaAtualMaiorQueIntervalo(paginaAtual) {
  return paginaAtual > INTERVALO;
}

function isPaginaAtualMenorQueUltima(paginaAtual, ultimaPagina) {
  return paginaAtual + INTERVALO < ultimaPagina;
}

function numeroElementoInicio() {
  return this.paginaAtual * this.tamanhoPagina + 1;
}

function numeroElementoFim() {
  let total = (this.paginaAtual + 1) * this.tamanhoPagina;
  if (total > this.totalElementos) {
    return this.totalElementos;
  }
  return (this.paginaAtual + 1) * this.tamanhoPagina;
}
</script>
